import { Form, Formik } from 'formik'
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import * as Yup from 'yup'
import { Button, Typography } from '../../../components'
import ErrorMessage from '../../../components/Form/ErrorMessage'
import Input from '../../../components/Form/Input'
import { FormBody, FormFooter } from '../../../components/Form/styles'
import useActions from '../../../hooks/useActions'
import useScrollToTop from '../../../hooks/useScrollToTop'
import { signUpActions } from '../../../redux/ducks/signUp'
import { onlyNumbers } from '../../../utils/onlyNumbers'
import { isAvailableEmail } from '../../../helpers/isAvailableEmail'

import * as S from '../styles'

const formSchema = Yup.object().shape({
  name: Yup.string()
    .required('Campo obrigatório')
    .max(50, 'Máximo de 50 caracteres'),
  lastname: Yup.string()
    .required('Campo obrigatório')
    .max(50, 'Máximo de 50 caracteres'),
  // document: Yup.string()
  //   .required('Campo obrigatório')
  //   .test('document', 'CPF inválido', (value) => validateCPF(value)),
  cellphone: Yup.string()
    .required('Campo obrigatório')
    .test(
      'cellphone',
      'Celular inválido',
      (value) => onlyNumbers(value).length === 11
    )
    .matches(
      /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}\-[0-9]{4}$/,
      'Celular inválido'
    ),
  email: Yup.string()
    .required('Campo obrigatório')
    .email('Email inválido')
    .test(
      'email',
      'Email já cadastrado',
      async (value) => (await isAvailableEmail(value)) ?? true
    ),
  password: Yup.string()
    .required('Campo obrigatório')
    .max(50, 'Máximo de 50 caracteres')
    .matches(
      /(\b(?:([A-Za-z0-9])(?!\2{2}))+\b)/,
      'A senha não deve conter caracteres repetidos'
    ),
  confirmPassword: Yup.string()
    .required('Confirme sua senha')
    .max(50, 'Máximo de 50 caracteres')
    .oneOf([Yup.ref('password'), ''], 'Confirmação de senha incorreta')
})

const StepTwo = () => {
  const { setStep2, nextStep, prevStep } = useActions(signUpActions)
  const { step2 } = useSelector((state) => state.signUp)
  const [formError] = useState('')
  const { scrollToTop } = useScrollToTop()

  const { id: _, ...initialValues } = step2

  useEffect(() => {
    scrollToTop()
  }, [scrollToTop])

  const onSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true)
    await setStep2(values)
    setSubmitting(false)
    nextStep()
  }

  return (
    <S.StepContainer>
      <Typography
        type="text"
        color="#7D7987"
        spacing="0 0 1.5rem 0"
        align="center"
      >
        Precisamos de alguns dados para o cadastro
      </Typography>
      <Formik
        initialValues={initialValues}
        validationSchema={formSchema}
        onSubmit={onSubmit}
        validateOnChange={false}
      >
        {({ isSubmitting }) => (
          <Form>
            <FormBody>
              <S.InputContainer>
                <Input
                  name="name"
                  label="Nome"
                  showValidIcon
                  display="inline-block"
                />
                <Input
                  name="lastname"
                  label="Sobrenome"
                  showValidIcon
                  display="inline-block"
                />
              </S.InputContainer>
              {/* <Input
                name="document"
                label="CPF"
                showValidIcon
                mask="999.999.999-99"
              /> */}
              <Input
                name="cellphone"
                label="Celular"
                showValidIcon
                mask="(99) 99999-9999"
              />
              <Input name="email" label="Email" showValidIcon />
              <Input name="password" type="password" label="Senha" />
              <Input
                name="confirmPassword"
                type="password"
                label="Confirmar senha"
              />
              <ErrorMessage>{formError}</ErrorMessage>
            </FormBody>
            <FormFooter>
              <Button
                text="VOLTAR"
                type="button"
                variant="outlined"
                width="200px"
                onClick={prevStep}
              />
              <Button
                text="PROSSEGUIR"
                type="submit"
                variant="primary"
                width="200px"
                disabled={isSubmitting}
              />
            </FormFooter>
          </Form>
        )}
      </Formik>
    </S.StepContainer>
  )
}

export default StepTwo
